import { tv } from 'tailwind-variants'

export const linkWebStyles = tv({
	base: 'text-palette_3 select-text underline underline-offset-4 text-base font-apercu-bold',
})

export const linkNativeStyles = tv({
	base: 'text-palette_3 text-base font-apercu-bold',
})
